import { AdminTab} from "./AdminTab";

export default AdminTab;
